@use '../../../../../styles/Colors.scss' as Colors;
@use '../../../../../styles/Constants.scss' as Constants;
@use '../../../../../components/Table/styles.module.scss' as Table;

.job-work-summary {

	&__table-header {
		font-size: Constants.$val-fontSizeSmall;

		&>span {
			text-transform: uppercase;
		}

		&>b {
			margin-left: Constants.$val-spacing-s;
		}
	}

	&__sub-row-cell {
		color: Colors.$col-greyFontLight;
		font-size: Constants.$val-fontSizeSmall;
	}

	&__no-billing-code {
		color: Colors.$col-greyFontLight;
		font-style: italic;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		font-size: Constants.$val-fontSizeSmall;
	}

	&__empty-cell {
		color: Colors.$col-greyFontLight;
		font-size: Constants.$val-fontSizeSmall;

		&--right-aligned {
			display: flex;
			justify-content: flex-end;
			width: 100%;
		}
	}

	&__info-icon {
		color: Colors.$col-greyFontLight;
		padding-left: Constants.$val-spacing-xxs;
	}

	&__review-status-cell {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;

		&--draft {
			[class^="icon-dot"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-greyFontLight;
			}
		}

		&--in-progress {
			[class^="icon-dot"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-orange;
				font-weight: bold;
			}
		}

		&--outdated {
			[class^="icon-dot_outline"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-orange;
				font-weight: bold;
			}
		}

		&--reviewed {
			[class^="icon-dot"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-darkBlueBorder;
				font-weight: bold;
			}
		}

		&--completed {
			[class^="icon-dot"] {
				margin-right: Constants.$val-spacing-s;
				color: Colors.$col-green;
				font-weight: bold;
			}
		}

		&--sub-row-cell {
			color: Colors.$col-greyFontLight;
		}

		&>b {
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}
	}

	.table-container__table__body {
		height: calc(100vh - Table.$var-company-header-height - Table.$var-breadcrumbs-header-height - Table.$var-tabs-navigation-height - Table.$var-table-header-height - Table.$var-table-action-header-height - Table.$var-table-footer-height - 4 * Constants.$val-spacing-xl);
	}
}

.action-cell {
	display: relative;
	transform: translateX(- Constants.$val-spacing-m);
}
